import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { ReactNode } from 'react'

interface TrombiLinkProps {
  href: string
  children: ReactNode
}

export default function TrombiLink({ href, children }: Readonly<TrombiLinkProps>) {
  const isExternal = !/^https?:\/\/trombi\..*$/.exec(href)
  return (
    <a
      href={href}
      {...(isExternal ? { target: '_blank' } : {})}
    >
      {children}
      {isExternal && <OpenInNewIcon fontSize="inherit" />}
    </a>
  )
}
